import { Component } from '@angular/core';
import { SalesForceAuthService } from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgb-sales-force-user-login',
  templateUrl: './sales-force-user-login.component.html',
  styleUrl: './sales-force-user-login.component.scss',
})
export class SalesForceUserLoginComponent {
  constructor(private salesForceAuthService: SalesForceAuthService) {}

  loginSalesForce() {
    firstValueFrom(this.salesForceAuthService.login());
  }
}
